import React from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';
import ttt from '@xing-com/ticktricktrack';

import { TrackingPropsContext } from '../contexts/tracking-props-context';
import { getPropInteractionType } from '../utils/tracking/get-prop-interaction-type';
export type UseTrackShareFormOpenedType = (props: {
  audience?: string;
  toChannel: 'startpage' | 'messenger';
  verb?: 'SHARE' | 'POST';
}) => void;

export const useTrackShareFormOpened: UseTrackShareFormOpenedType = ({
  audience,
  toChannel,
  verb = 'SHARE',
}) => {
  const {
    interactionTargetUrn,
    propSocialInteractionId,
    propSourceType,
    propChannel,
    entryPoint,
    inputHintClick,
    backendTrackingMetaData,
    trackingToken,
  } = React.useContext(TrackingPropsContext);
  const { track } = useTracking();
  const { page, trackingTokens } = backendTrackingMetaData;

  React.useEffect(() => {
    track({
      type: 'nwt',
      event: 'intended',
      intention: 'share',
      itemUrn: interactionTargetUrn,
      sentBy: 'social',
      page: page?.toLowerCase(),
      trackingToken: trackingToken || trackingTokens?.[0],
      application: 'wbm',
      audience:
        toChannel === 'messenger'
          ? 'private_message'
          : verb === 'SHARE'
            ? 'startpage_with_comment'
            : verb === 'POST'
              ? 'startpage'
              : 'startpage',
      eventSchema: 'extended',
    });

    ttt.event('EventShareBoxOpen', {
      EventShareBoxOpen: 1,
      PropInteractionType: getPropInteractionType(
        toChannel,
        interactionTargetUrn,
        propSourceType
      ),
      PropActionOrigin:
        audience === 'PUBLIC'
          ? 'social_share_audience_public'
          : 'social_share_audience_my_contacts',
      PropSocialObjectId: interactionTargetUrn,
      PropSocialInteractionId: propSocialInteractionId,
      PropChannel: propChannel,
      ...(inputHintClick && {
        PropContextDimension3: 'social_overview_comment_click',
      }),
      ...(toChannel === 'messenger' && {
        EventMessengerChatOpen: 1,
        EventMessengerNewChatCreate: 1,
        PropMessengerContext: `open|1:1|social_share|${entryPoint || 'misc'}`,
      }),
    });
  }, [audience]);
};
